import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as types from '../types';

/** Long enough for the coupon lookup on a slow phone; short enough that a failed one doesn't strand the page. */
const COUPON_WAIT_MS = 8000;

/**
 * Whether the one-page checkout can show prices: once the adoption coupon is on the cart, or after a
 * timeout if it never lands. Every adopter on this page arrived through a rescue link, so the coupon is
 * always expected; `useAutoApplyCoupon` applies it a moment after the cart fills (or after the `fi_c`
 * token exchange), and a checkout mounted before then shows, and could take payment at, the regular
 * membership price. Past the timeout the checkout shows whatever the cart is priced at, as the bag would.
 */
export default function useRescueCouponReady() {
  const couponApplied = useSelector((state: types.AppState) => !!state.storeShop.cart.couponCode);
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    if (couponApplied) {
      return;
    }
    const timer = setTimeout(() => setTimedOut(true), COUPON_WAIT_MS);
    return () => clearTimeout(timer);
  }, [couponApplied]);

  return couponApplied || timedOut;
}
